import { render, staticRenderFns } from "./AppAccessSwitch.vue?vue&type=template&id=3bc3bf6f&scoped=true"
import script from "./AppAccessSwitch.vue?vue&type=script&lang=js"
export * from "./AppAccessSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc3bf6f",
  null
  
)

export default component.exports